module.exports = __webpack_public_path__ + "img/fig13.1a1264a0.jpg";